<template>
	<v-app>
		<div class="row background-recovery" style="margin: 0px;overflow-y:hidden;">
			<v-container id="qr" wrap>
				<v-layout justify-center>
					<v-flex xs12 sm7 md7 lg6 xl5>
						<v-slide-y-transition>
							<v-card height="95.1vh" style="max-height: 95.1vh;" class="scrollDesign">
								<v-container bg fill-height grid-list-md text-xs-center>
									<v-layout wrap align-center>
										<v-flex xs8 offset-xs2>
											<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
										</v-flex>
										<v-slide-y-transition mode="out-in">
											<v-flex xs8 offset-xs2 v-if="flags.error && !flags.loading" :key="0">
												<h2>
													<b>{{ flags.eMessage }}</b>
												</h2>
											</v-flex>
											<v-flex v-else-if="steps.step1" xs8 offset-xs2 :key="1">
												<v-flex xs6 offset-xs3>
													<v-img :src="require('@/assets/qr/SKLB-Solicitud.png')"></v-img>
												</v-flex>
												<h2>
													<b>GENERADOR DE QR</b>
												</h2>
												<h3>
													<b>
														¡Hola! Tienes una solicitud de {{ QRInfo.parent.firstName + ' ' +
														QRInfo.parent.lastName}} para pasar al colegio {{ QRInfo.branch.name }}
													</b>
												</h3>
												<v-list subheader>
													<v-list-tile :key="0" avatar>
														<v-list-tile-avatar>
															<v-icon>event</v-icon>
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ QRInfo.date | dateString }}</v-list-tile-title>
															<v-list-tile-sub-title></v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-list-tile :key="1" avatar>
														<v-list-tile-avatar>
															<v-icon>place</v-icon>
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ QRInfo.branch.name }}</v-list-tile-title>
															<v-list-tile-sub-title>{{ QRInfo.branch.address }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-list-tile v-for="lvl in QRInfo.levels" :key="lvl.id" avatar>
														<v-list-tile-avatar>
															<img :src="require('@/assets/panel/home/SKLB-Niveles.png')" alt />
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ lvl.typeLevel }}</v-list-tile-title>
															<v-list-tile-sub-title>{{ lvl.departureTime }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
												</v-list>
												<v-btn dark block round color="gradiente" @click="step('2')">Aceptar</v-btn>
											</v-flex>
											<v-flex v-else-if="steps.step2" :key="2" xs8 offset-xs2>
												<v-flex xs6 offset-xs3>
													<v-img :src="require('@/assets/qr/SKLB-Numero Tel.png')"></v-img>
												</v-flex>
												<h3>
													<b>
														Es necesario que proporciones tu número telefónico
														para generar tu código QR.
													</b>
												</h3>
												<br />
												<h4>No realizaremos llamadas ni mensajes promocionales a este número.</h4>
												<v-form lazy-validation @submit.prevent="step('3')">
													<v-text-field
														:error-messages="telephoneErrors"
														v-model="firstForm.telephone"
														label="Teléfono"
														type="tel"
													></v-text-field>
													<p>
														Si continúas, estarás aceptando los
														<span
															class="red--text"
															style="text-decoration: underline;"
														>términos y condiciones de uso</span>
													</p>
													<br />
													<v-btn type="submit" dark color="gradiente" block round>Continuar</v-btn>
												</v-form>
											</v-flex>
											<v-flex v-else-if="steps.step3" :key="3" xs8 offset-xs2>
												<v-flex xs6 offset-xs3>
													<v-img :src="require('@/assets/qr/SKLB-ID.png')"></v-img>
												</v-flex>
												<h2>
													<b>
														<span class="red--text">Tu identificación</span> te será solicitada al llegar a la escuela. Recuerda llevarla contigo.
													</b>
												</h2>
												<p>Favor de llenar los campos acorde a tu identifiación oficial</p>
												<v-form lazy-validation @submit.prevent="step('4')">
													<v-text-field
														:error-messages="firstNameErrors"
														v-model="secondForm.firstName"
														label="Nombre(s)"
													></v-text-field>
													<v-text-field
														:error-messages="lastNameErrors"
														v-model="secondForm.lastName"
														label="Apellidos"
													></v-text-field>
													<br />
													<v-btn type="submit" dark color="gradiente" block round>Continuar</v-btn>
												</v-form>
											</v-flex>
											<v-flex v-else-if="steps.step4" :key="4" xs8 offset-xs2>
												<v-flex xs6 offset-xs3>
													<v-progress-circular
														v-if="QRInfo.qrImage == '' || working.loading"
														indeterminate
														color="primary"
													></v-progress-circular>
													<v-img v-else-if="!flags.errorImage" :src="QRInfo.qrImage"></v-img>
													<p v-else>No nos fue posible recuperar el QR, inténtalo más tarde.</p>
												</v-flex>
												<h4>
													<b>
														No pierdas tu código QR,
														<a @click="download">descárgalo</a>, será necesario para pasar por los niños.
													</b>
												</h4>
												<v-list subheader>
													<v-list-tile :key="0" avatar>
														<v-list-tile-avatar>
															<v-icon>event</v-icon>
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ QRInfo.date | dateString }}</v-list-tile-title>
															<v-list-tile-sub-title></v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-list-tile :key="1" avatar>
														<v-list-tile-avatar>
															<v-icon>place</v-icon>
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ QRInfo.branch.name }}</v-list-tile-title>
															<v-list-tile-sub-title>{{ QRInfo.branch.address }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-subheader>Niveles</v-subheader>
													<v-list-tile v-for="lvl in QRInfo.levels" :key="lvl.id" avatar>
														<v-list-tile-avatar>
															<img :src="require('@/assets/panel/home/SKLB-Niveles.png')" alt />
														</v-list-tile-avatar>
														<v-list-tile-content>
															<v-list-tile-title>{{ lvl.typeLevel }}</v-list-tile-title>
															<v-list-tile-sub-title>{{ lvl.departureTime }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-subheader>Alumnos</v-subheader>
													<v-list-tile v-for="student in QRInfo.students" :key="student.id" avatar>
														<v-list-tile-avatar>
															<img :src="require('@/assets/panel/home/SKLB-Alumnos.png')" alt />
														</v-list-tile-avatar>

														<v-list-tile-content>
															<v-list-tile-title>{{ student.firstName }}</v-list-tile-title>
															<v-list-tile-sub-title>{{ student.lastName }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
												</v-list>
											</v-flex>
										</v-slide-y-transition>
									</v-layout>
								</v-container>
							</v-card>
						</v-slide-y-transition>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
	</v-app>
</template>

<script>
	import jsPDF from "jspdf";
	import { required } from "vuelidate/lib/validators";
	import { imageTools } from "../../Mixins/imageTools";
	import { pdfMixin } from "../../Mixins/PdfMixin";
	export default {
		mixins: [imageTools, pdfMixin],
		validations: {
			firstForm: {
				telephone: {
					required,
					verify(value) {
						return value == this.QRInfo.phone;
					}
				}
			},
			secondForm: {
				firstName: { required },
				lastName: { required }
			}
		},
		data: () => ({
			firstForm: {
				telephone: ""
			},
			secondForm: {
				firstName: "",
				lastName: ""
			},
			flags: {
				normal: false,
				loading: false,
				valid: false,
				error: false
			},
			QRInfo: {
				parent: {},
				branch: {},
				qrImage: ""
			},
			flags: {
				error: false,
				eMessage: "",
				codeVerified: false,
				errorImage: false
			},
			steps: {
				step1: true,
				step2: false,
				step3: false,
				step4: false
			},
			working: {
				loading: false
			}
		}),
		beforeMount() {
			if (this.getUriVars.id == null) {
				this.flags.error = true;
				this.flags.eMessage =
					"AL PARECER NO TIENES IDENTIFICADOR VÁLIDO PARA ESTAR AQUÍ";
			} else {
				this.flags.codeVerified = true;
			}
		},
		mounted() {
			if (!this.flags.error) {
				var body = {
					code: this.getUriVars.id
				};
				body = Object.keys(body)
					.map(function(k) {
						return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
					})
					.join("&");
				this.$store
					.dispatch("login/readCodeThirdQR", body)
					.then(response => {
						this.QRInfo = response.data.entity;
						if (this.QRInfo.qrImage != null) {
							this.QRInfo.qrImage =
								"data:image/png;base64," + response.data.entity.qrImage;
							this.step("2");
						}
					})
					.catch(error => {
						this.flags.error = true;
						this.flags.eMessage =
							"AL PARECER NO TIENES IDENTIFICADOR VÁLIDO PARA ESTAR AQUÍ";
						console.log(error);
					});
			}
		},
		filters: {
			dateString(date) {
				var months = [
					"Enero",
					"Febrero",
					"Marzo",
					"Abril",
					"Mayo",
					"Junio",
					"Julio",
					"Agosto",
					"Septiembre",
					"Octubre",
					"Noviembre",
					"Diciembre"
				];
				var daysWeek = [
					"Domingo",
					"Lunes",
					"Martes",
					"Miercoles",
					"Jueves",
					"Viernes",
					"Sabado"
				];
				if (!date) return "";
				var d = new Date(date);
				return (
					daysWeek[d.getDay()] +
					", " +
					d.getDate() +
					" de " +
					months[d.getMonth()]
				);
			}
		},
		methods: {
			step(step) {
				switch (step) {
					case "1":
						this.steps.step3 = false;
						this.steps.step2 = false;
						this.steps.step1 = true;
						this.steps.step4 = false;
						break;
					case "2":
						this.steps.step2 = true;
						this.steps.step1 = false;
						this.steps.step3 = false;
						this.steps.step4 = false;
						break;
					case "3":
						this.$v.firstForm.$touch();
						if (!this.$v.firstForm.$invalid) {
							if (
								this.QRInfo.qrImage != null &&
								this.QRInfo.qrImage != " " &&
								this.QRInfo.qrImage != ""
							) {
								this.steps.step2 = false;
								this.steps.step3 = false;
								this.steps.step1 = false;
								this.steps.step4 = true;
							} else {
								this.steps.step2 = false;
								this.steps.step3 = true;
								this.steps.step1 = false;
								this.steps.step4 = false;
							}
						}
						break;
					case "4":
						this.$v.secondForm.$touch();
						if (!this.$v.secondForm.$invalid) {
							this.steps.step2 = false;
							this.steps.step3 = false;
							this.steps.step1 = false;
							this.steps.step4 = true;
							if (this.QRInfo.qrImage == "" || this.QRInfo.qrImage == null) {
								this.generateQR();
							}
						}
						break;
				}
			},
			download() {
				var parent = {
					firstName: this.QRInfo.firstName,
					lastName: this.QRInfo.lastName,
					phone: this.QRInfo.phone,
					date: this.$options.filters.dateString(this.QRInfo.date),
					qr: this.QRInfo.qrImage
				};
				this.downloadThirdQR(parent, 100);
			},
			generateQR() {
				this.working.loading = true;
				var body = {
					code: this.QRInfo.token,
					phone: this.QRInfo.phone,
					firstName: this.secondForm.firstName,
					lastName: this.secondForm.lastName
				};
				body = Object.keys(body)
					.map(function(k) {
						return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
					})
					.join("&");
				this.$store
					.dispatch("login/generateQR", body)
					.then(response => {
						this.QRInfo = response.data.entity;
						this.QRInfo.qrImage =
							"data:image/png;base64," + response.data.entity.qrImage;
						this.working.loading = false;
					})
					.catch(error => {
						this.flags.errorImage = true;
						this.working.loading = false;
					});
			}
		},
		computed: {
			getUriVars() {
				let uri = window.location.href.split("?");
				if (uri.length == 2) {
					let vars = uri[1].split("&");
					let getVars = {};
					let tmp = "";
					vars.forEach(function(v) {
						tmp = v.split("=");
						if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
					});
					return getVars;
				}
				return {};
			},
			firstNameErrors() {
				const errors = [];
				if (!this.$v.secondForm.firstName.$dirty) return errors;
				!this.$v.secondForm.firstName.required && errors.push("Nombre requerido");
				return errors;
			},
			lastNameErrors() {
				const errors = [];
				if (!this.$v.secondForm.lastName.$dirty) return errors;
				!this.$v.secondForm.lastName.required &&
					errors.push("Apellidos requeridos");
				return errors;
			},
			telephoneErrors() {
				const errors = [];
				if (!this.$v.firstForm.telephone.$dirty) return errors;
				!this.$v.firstForm.telephone.required &&
					errors.push("Teléfono requerido");
				!this.$v.firstForm.telephone.verify &&
					errors.push("El teléfono no concuerda con la invitación");
				return errors;
			}
		}
	};
</script>

<style>
	.background-recovery {
		background: url(../../assets/recovery/qrRegister.png) no-repeat center center
			fixed;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}
</style>
